import Evaluation from '@/components/Expert/legacy/Evaluation';

export default function ExpertValuePanel({ expertId }) {
    if (!expertId) {
        return null;
    }

    return (
        <div className="expert-profile-value-panel">
            <Evaluation expertId={expertId} />
        </div>
    );
}
